import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { getInitialReleaseState, IReleaseState } from "./CreateRelease.state";

const initialState = getInitialReleaseState();

export const createReleaseManager = createSlice({
  name: "createRelease",
  initialState: initialState,
  reducers: {
    addRelease: actionProcessing.createWithClearNotification((state: IReleaseState) => {
      return {
        ...state,
        isLoading: true
      };
    }),
    addReleaseCompleted: (state, action: PayloadAction<INotification>) => {
      return {
        ...state,
        isLoading: false,
        shouldHide: true,
        notifications: [action.payload]
      };
    },
    addReleaseFailed: (state, action: PayloadAction<INotification>) => {
      return { ...state, isLoading: false, notifications: [action.payload] };
    },
    changeNameFieldValue: (state: IReleaseState, action: PayloadAction<string>): IReleaseState => {
      return { ...state, releaseName: action.payload };
    },
    setTextValidationError: (state: IReleaseState, action: PayloadAction<string>): IReleaseState => {
      return { ...state, textValidationError: action.payload };
    },
    clearState: (state: IReleaseState): IReleaseState => {
      return { ...state, ...initialState };
    }
  },
  extraReducers: getScreenExtraReducers<IReleaseState>("notifications", initialState)
});
